import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import { Container, Form, InputGroup } from 'react-bootstrap';
import MetaData from '../MetaData';
import SectionHeading from '../common/SectionHeading';
import { clearErrors } from '../../redux/actions/orderActions';
import { deleteReviews, getAllReviews } from '../../redux/actions/productAction';
import { BsFillTrashFill } from 'react-icons/bs';
import Table from 'react-bootstrap/Table';
import { useNavigate, Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Row, Col } from 'react-bootstrap';
import { DELETE_REVIEW_RESET } from '../../redux/constants/productConstants';
import { AiOutlineUser } from 'react-icons/ai';

const ProductReviews = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, reviews, error } = useSelector((state) => state.productReviews);
    const { isDeleted, error: deleteError } = useSelector((state) => state.review);
    const [productId, setProductId] = useState('');

    useEffect(() => {
        if (productId.length === 24) {
            dispatch(getAllReviews(productId));
        }

        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (deleteError) {
            toast.error(deleteError);
            dispatch(clearErrors());
        }

        if (isDeleted) {
            toast.success('Review deleted successfully');
            dispatch({ type: DELETE_REVIEW_RESET });
            navigate('/admin/reviews');
        }

        // dispatch(getAllReviews());
    }, [error, deleteError, isDeleted, productId]);

    const handleDeleteReview = (reviewId) => {
        dispatch(deleteReviews(reviewId, productId));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(getAllReviews(productId));
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={`All Reviews - Admin`} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <SectionHeading heading={'All Reviews'} />
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            <form onSubmit={handleSubmit} className='createProductForm mb-4'>
                                <h4 className='text-center mb-4 formHeading'>Search Reviews</h4>
                                <InputGroup className='mb-3'>
                                    <InputGroup.Text id='basic-addon1'>
                                        <AiOutlineUser />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder='ProductID'
                                        aria-label='ProductID'
                                        name='ProductID'
                                        type='text'
                                        value={productId}
                                        onChange={(e) => setProductId(e.target.value)}
                                    />
                                </InputGroup>
                                <input
                                    type='submit'
                                    value='Search'
                                    className='submitBtn'
                                    disabled={loading || productId === '' ? true : false}
                                />
                            </form>
                            {reviews && reviews.length > 0 ? (
                                <div className='scrollableTable'>
                                    <Table striped bordered hover className='commonTable'>
                                        <thead>
                                            <tr>
                                                <th>Review ID</th>
                                                <th>Name</th>
                                                <th>Comment</th>
                                                <th>Rating</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reviews &&
                                                reviews.length > 0 &&
                                                reviews.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item._id}</td>
                                                        <td>{item.name}</td>
                                                        <td>{item.comment}</td>
                                                        <td
                                                            className={
                                                                item.rating >= 3
                                                                    ? 'text-success'
                                                                    : 'text-danger'
                                                            }
                                                        >
                                                            {item.rating}
                                                        </td>
                                                        <td>
                                                            <button
                                                                className='common-btn'
                                                                onClick={() =>
                                                                    handleDeleteReview(item._id)
                                                                }
                                                            >
                                                                <BsFillTrashFill />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </Table>
                                </div>
                            ) : (
                                <div className='noDataFound'>No Reviews Found</div>
                            )}
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default ProductReviews;
